import React from 'react'
import { Icon, Menu } from 'semantic-ui-react'

export default function BillingInvoicePdfItem ({ billingInvoice }) {
  if (!billingInvoice.pdfUrl) return null

  return (
    <Menu.Item as="a"
               href={billingInvoice.pdfUrl}
               target="_blank"
               rel="noopener noreferrer"
               onClick={(e) => e.stopPropagation()}
               title="Download PDF">
      <Icon name="file pdf outline"/>
    </Menu.Item>
  )
}
